import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import moment from 'moment';
import { Subject } from 'rxjs';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';

@Component({
  selector: 'app-companies-report',
  templateUrl: './companies-report.component.html',
  styleUrls: ['./companies-report.component.scss']
})
export class CompaniesReportComponent implements OnInit {

  totalCompanies: number = 0;
  submiting: boolean = false;
  chartWidth: number = 0;
  @ViewChild('chartContainer', { static: false }) chartContainer!: ElementRef<any>;
  chartData: any = [
    {
      name: "Empresas Cadastradas",
      series: []
    }
  ]

  constructor(
    private http: HttpService,
    private errorReport: ErrorReportService,
    private snapshat: MatSnackBar
  ) { }

  ngOnInit(): void {
    const subject = new Subject<any>();
    subject.subscribe(({ trigger, scope }: any) => {
      if (scope == 'analytics:companies') {
        this.submiting = trigger == 'pre';
      }

    })
    this.http.setLoadingIndicator(subject, 'analytics:companies')

  }

  getCompanies() {

    this.http.list('analytics:companies')
      .subscribe(
        (companies: any) => {

          if (companies.by_dates.length > 0) {
            this.totalCompanies = companies.total
            this.chartData[0].series = companies.by_dates.map((item: any) => ({
              name: moment(item.date_added).format('DD/MM/YYYY'),
              value: item.records
            }));
            setTimeout(() => {
              this.chartWidth = this.chartContainer.nativeElement.clientWidth;
            }, 250)
          } else this.snapshat.open('Sem cadastrado encontrados', 'OK', { duration: 3000 })
        },
        (error) => this.errorReport.showMessage(error)
      )

  }

}
